// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { createBrowserRouter, RouteObject, Navigate } from 'react-router-dom'

import AuthenticatedApp from '@/app/shared/components/AuthenticatedApp'
import RootBoundary from '@/app/shared/components/Layout/RootBoundary'
import CustomerManagement from '@/app/CustomerManagement'
import Customer from '@/app/CustomerManagement/pages/Customer'
import ActivePractices from '@/app/CustomerManagement/pages/Customer/ActivePractices'
import ArchivedPractices from '@/app/CustomerManagement/pages/Customer/ArchivedPractices'
import Practice from '@/app/CustomerManagement/pages/Practice'
import Template from '@/app/Templates/pages/Template'
import Templates from '@/app/Templates'

const routes: RouteObject[] = [
  {
    path: '/',
    element: <AuthenticatedApp />,
    errorElement: <RootBoundary />,
    children: [
      { index: true, element: <Navigate to="/customer-management" replace /> },
      { path: 'customer-management', element: <CustomerManagement /> },
      {
        path: 'customer-management/:customerId',
        element: <Customer />,
        children: [
          {
            index: true,
            element: <Navigate to="active" replace />,
          },
          {
            path: 'active',
            element: <ActivePractices />,
          },
          {
            path: 'archived',
            element: <ArchivedPractices />,
          },
        ],
      },
      {
        path: 'customer-management/:customerId/practices/:practiceId',
        element: <Practice />,
      },
      { path: 'templates', element: <Templates /> },
      { path: 'templates/:templateId', element: <Template /> },
    ],
  },
]

export const router = createBrowserRouter(routes)
